import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const removedElement = style({
  display: "flex",
  flexDirection: "column",
  paddingBottom: vars.space.l,
  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      paddingBottom: vars.space.xl,
    },
  },
});
